import { stringify } from 'query-string';
import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';
import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { MentionContextIdentifier, MentionDescription } from '@atlaskit/mention';
import type { AccountId, IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';
import { AbstractMentionProvider } from '../abstract-mention-provider/index.tsx';

export class UserMentionProvider extends AbstractMentionProvider {
	constructor(
		issueKey: IssueKey,
		loggedInAccountId: AccountId | null,
		projectType?: ProjectType | null,
		createAnalyticsEvent?: CreateUIAnalyticsEvent | null,
	) {
		super(projectType, createAnalyticsEvent);
		this.issueKey = issueKey;
		this.loggedInAccountId = loggedInAccountId;
	}

	getQueryString = (query?: string, contextIdentifier?: MentionContextIdentifier) =>
		stringify({
			query,
			issueKey: this.issueKey,
			maxResults: 10,
			...contextIdentifier,
		});

	getUrl = (queryString: string) => `/rest/internal/2/user/mention/search?${queryString}`;

	issueKey: string;

	loggedInAccountId: string | null;

	shouldHighlightMention = (mention: MentionDescription) => mention.id === this.loggedInAccountId;
}
